export default __webpack_public_path__ + "locales/es/UploadPanel.json?hash=1654b097d2b9535331b2bf98c77ece8b";